<template>
    <div class="conference-program">
        <div class="title">
            <h3>
                <em></em>
                <span>{{ t('conferenceProgram.title') }}</span>
                <em></em>
            </h3>
        </div>
        <div class="program-container" id="conference">
            <div class="program-content">
                <!-- <div class="program-tip"><p style="color: #333;">To be announced...</p></div> -->
                <table class="responstable">
                    <tbody>
                        <tr>
                            <td colspan="2" class="date-header">
                                <p class="date-text">
                                    <strong>Friday, November 21st, 2025</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="session-header">
                                <p class="session-title">
                                    <strong>OPENING SESSION</strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST: SAMUEL WAXMAN & RUIBAO REN</strong>
                                </p>
                            </td>
                        </tr>

                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="content-column"></td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">8:30-8:35 AM</p>
                            </td>
                            <td class="content-column">
                                <p class="content-text">
                                    <strong>Weiguo Zou,</strong> Vice President (in person)
                                </p>
                                <p class="content-text">
                                    Hainan Medical University (Hainan Academy of Medical Sciences)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">8:35-8:40 AM</p>
                            </td>
                            <td class="content-column">
                                <p class="content-text">
                                    <strong>Samuel Waxman,</strong> Founder & CEO
                                </p>
                                <p class="content-text">
                                    The Samuel Waxman Cancer Research Foundation
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">8:40-8:45 AM</p>
                                <p class="time-text">(EST, 20/11/2025, 7:40-7:45 PM)</p>
                            </td>
                            <td class="content-column">
                                <p class="content-text">
                                    <strong>Ryan Schoenfeld,</strong>Ph.D., CEO (online)
                                </p>
                                <p class="content-text">
                                    The Mark Foundation for Cancer Research
                                </p>
                            </td>
                        </tr>

                    </tbody>
                </table>
                <table class="responstable">
                    <tbody>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">
                                    <strong>MORNING SESSION</strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST:</strong> SAMUEL WAXMAN &amp; RUIBAO REN
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong>TITLE</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong>SPEAKER</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    8:45-9:15 AM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Prevention and treatment of non-communicable diseases in aging society
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Zhu Chen (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Vice Chairman of the Standing Committee of the 12th and 13th National People's Congress, Academician of the Chinese Academy of Sciences.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    9:15-9:30 AM
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>GROUP PHOTO & COFFEE BREAK</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                   9:30-9:55 AM
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    TRF2 Expression as a Regulatory Process of Aging
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Eric Gilson (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Institute for Research on Cancer and Aging, Nice (IRCAN).
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    9:55-10:20 AM
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                                <p class="time-text">
                                    (EST, 20/11/2025, 8:55-9:20 PM)
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    <em>TBD</em>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Sandra McAllister (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Harvard Medical School.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    <strong>10:20-10:45 AM</strong>
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Self-renewal Activity of Hematopoietic Stem Cells from the Birth to Aged
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Toshio Suda (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Chinese Academy of Medical Sciences & Peking Union Medical College.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    10:45-11:10 AM
                                </p>
                                <p class="time-text">
                                    (PST, 20/11/2025, 6:45-7:10 PM)
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Long term persistence of mutant stem cells: roles in inflammation, cancer and aging.
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Allan Balmain (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Helen Diller Family Comprehensive Cancer Center, UCSF.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    11:10-11:35 AM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Microglia replacement from bench to clinical therapies
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Bo Peng (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Fudan University.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    11:35-11:45 AM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Introduction of <strong><em>Aging and Cancer</em></strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>James DeGregori (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    <strong><em>Aging and Cancer</em></strong> Editor
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    11:45-11:55 AM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Introduction of <strong><em>Cell Investigation</em></strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Ruibao Ren (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    <strong><em>Cell Investigation</em></strong> Editor
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    11:55-12:05 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    <strong>Inaugural Ceremony</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-affiliation">
                                    Chinese Health Promotion Foundation - Association of Aging Intervention and Chronic Disease Control 
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    <strong>12:05-1:30 PM</strong>
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>LUNCH TIME</strong>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="responstable">
                    <tbody>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">
                                    <strong>AFTERNOON SESSION</strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST:</strong> ZHIXIOANG XIAO &amp; WEI MO
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong>TITLE</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong>SPEAKER</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:00-2:25 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    De novo protein design assisted precise mitochondrial base editing
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Yangming Wang (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    College of Future Technology, Peking University
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:25-2:50 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    The TEL patch of TPP1 recruits Protein phosphatase 2A in competition with telomerase during aging
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Jing Ye (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Ruijin Hospital Affiliated to Shanghai Jiao Tong University School of Medicine.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:50-3:50 PM
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>*POSTER SESSION</strong>(COFFEE BREAK)
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">
                                    <strong>AFTERNOON SESSION</strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST:</strong> WEI MO &amp; YING GU
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    3:50-4:15 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    <span>The heterogeneity of senescent cells</span>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Ming Xu (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    University of Minnesota, College of Biological Sciences.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:15-4:40 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    A chemical approach toward creating life
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Sheng Ding (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Global Health Drug Discovery Institute.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:40-5:05 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Procr+ Chondroprogenitors Sense Mechanical Stimuli to Govern Articular Cartilage Maintenance and Regeneration
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Rui Yue (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Tongji University.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    5:05-5:30 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    IL-10/IL-10R-engaging engineered bacteria recalibrate tumor immunity
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Zhigaung Chang (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Hainan Medical University.
                                </p>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="responstable tr_see_more" style="">
                    <tbody>
                        <tr style="">
                            <td colspan="3" width="100%" style="text-align: left;">
                                <p>
                                    <strong><span style="font-family: 'Times New Roman';font-size: 22px">Saturday, November 22nd, 2025</span></strong>
                                </p>
                            </td>
                        </tr>
                        <tr style="">
                            <td colspan="3" width="100%" valign="center" nowrap="" style="">
                                <p style="text-align:center">
                                    <strong><span style="font-family: 'Times New Roman';font-size: 22px">OPENING
                                            SESSION</span></strong>
                                </p>
                                <p style="text-align:center">
                                    <span style="font-family: 'Times New Roman';font-size: 16px"><strong>HOST:</strong>
                                        JAMES DEGREGORI &amp; WENSHU WU</span>
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column" colspan="1">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="content-column" colspan="2"></td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">8:30–8:35</p>
                            </td>
                            <!-- <td></td> -->
                            <td class="content-column" colspan="2">
                                <p class="content-text"><strong>James DeGregori (in person)</strong></p>
                                <p class="content-text">The University of Colorado Anschutz Medical Campus School of Medicine</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="responstable tr_see_more">
                    <tbody>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">MORNING SESSION</p>
                                <p class="host-info"><strong>HOST:</strong> JAMES DEGREGORI & WENSHU WU</p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong>TITLE</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong>SPEAKER</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">8:35-9:00 AM</p>
                                <p class="time-text">(CST, 21/11/2025, 6:35-7:05 PM)</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Aging-associated microbial metabolite drives pre-leukemic conditions</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Daniel Starczynowski (online)</p>
                                <p class="speaker-affiliation">Cincinnati Children’s Hospital Medical Center.</p>
                            </td>
                        </tr>

                        <tr>
                            <td class="time-column">
                                <p class="time-text">9:00-9:25 AM</p>
                                <p class="time-text">(EST, 21/11/2025, 8:00-8:25 PM)</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Mapping RNA Splicing in Aging and Cancer</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Olga Anczuków (online)</p>
                                <p class="speaker-affiliation">The Jackson Laboratory for Genomic Medicine.</p>
                            </td>
                        </tr>


                        <tr>
                            <td class="time-column">
                                <p class="time-text">9:25-9:50 AM</p>
                                <p class="time-text">20min+5min Q & A</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Local Stem Cells as Drivers of Skeletal Disease</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Matthew Blake Greenblatt (in person)</p>
                                <p class="speaker-affiliation">Weill Cornell Medical College.</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">9:50-10:15 AM</p>
                                <p class="time-text">20min+5min Q & A</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Naked mole rats evolved a cGAS-mediated mechanism to potentiate DNA repair and delay aging</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Zhiyong Mao (online)</p>
                                <p class="speaker-affiliation">Tongji University</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text"><strong>10:15-10:30 AM</strong></p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text"><strong>COFFEE BREAK</strong></p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">10:30-10:55 AM</p>
                                <p class="time-text">(EST, 21/11/2025, 9:35-10:00 PM)</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Senolytics decrease senescent microglia, remodel the vasculature, and improve survival in older adults with glioblastoma during co-treatment with immunotherapy</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Manon Penco-Campillo (online)</p>
                                <p class="speaker-affiliation">Loyola University Chicago.</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">10:55-11:20 AM</p>
                                <p class="time-text">(PST, 21/11/2025, 6:55-7:20 PM)</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">Aging biomarkers and accelerated aging in survivors of childhood cancer</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Zhaoming Wang (online))</p>
                                <p class="speaker-affiliation">St. Jude Children's Research Hospital.</p>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td class="time-column">
                                <p class="time-text">11:20-11:50 AM</p>
                                <p class="time-text">20min+5min Q & A</p>
                                <p class="time-text">(CST, 21/11/2025, 9:20-9:50 PM)</p>
                            </td>
                            <td class="title-column">
                                <p class="title-text" >Age Reversal, Disease Interception</p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">Ronald A. DePinho (online)</p>
                                <p class="speaker-affiliation">UT MD Anderson Cancer Center.</p>
                            </td>
                        </tr> -->
                        <tr>
                            <td class="time-column">
                                <p class="time-text"><strong>12:00-1:30 PM</strong></p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text"><strong>LUNCH TIME</strong></p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="responstable tr_see_more">
                    <tbody>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">
                                    <strong>AFTERNOON SESSION</strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST:</strong> HAIYUN GAN &amp; JIANWEI WANG
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong>TITLE</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong>SPEAKER</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:00-2:25 PM
                                </p>
                                <p class="time-text">
                                    (PST, 21/11/2025, 10:00-10:25 PM)
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Common MLXIPL variation drives lipogenesis and may predispose to cancer
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Charles Brenner (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Beckman Research Institute of City of Hope.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:25-2:50 PM
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Novel Delivery Approaches to Inhibit Challenging Targets Underlying Cancer and Aging
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Hua Yu (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    City of Hope Comprehensive Cancer Center.
                                </p>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:25-2:50 PM
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                                <p class="time-text">
                                    (AST, 22/11/2025, 9:25-9:50 PM)
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    <em>TBD</em>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Brian Kennedy (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Yong Loo Lin School of Medicine, NUS. 
                                </p>
                            </td>
                        </tr> -->
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    2:50-3:15 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    SIRT1 bridges IGF-1 and p53 to regulate senescence and aging and targeted intervention.
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Zhixiong Xiao (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    College of Life Sciences, Sichuan University.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    3:15-4:15 PM
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>*POSTER SESSION</strong>(COFFEE BREAK)
                                </p>
                                <p class="break-text">
                                    <strong>HOST: WENSHU WU</strong>
                                </p>

                            </td>
                        </tr>
                        
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:15-4:40 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Transcription-dependent regulatory functions of bivalent transposons in development and disease
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Nian Liu (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Tsinghua University.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:40-5:05 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Pathogenetic pre-leukemic mutations: rare in clonal hematopoiesis but enriched in myeloid diseases
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Jing Zhang (in person)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    University of Wisconsin Madison.
                                </p>

                            </td>
                        </tr>
                        
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    5:05-5:30 PM
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    Epigenetics, Cancer and Longevity Medicine
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Yujiang Shi (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Fudan University.
                                </p>

                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    5:30-5:55 PM
                                </p>
                                <p class="time-text">
                                    20min+5min Q & A
                                </p>
                                <p class="time-text">
                                    (AST, 22/11/2025, 12:30-12:55 PM)
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                    The Longevity Revolution
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Brian Kennedy (online)</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Yong Loo Lin School of Medicine, NUS.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    5:55-6:25 PM
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>POSTER Certificate Presentation</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    6:25-6:35 PM
                                </p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">
                                    <strong>CLOSING REMARKS</strong>
                                </p>
                                <p class="break-text">
                                    <strong>HOST: JAMES DEGREGORI & RUIBAO REN</strong>
                                </p>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
                <!-- <table class="responstable tr_see_more" style="">
                    <tbody>
                        <tr style="">
                            <td colspan="3" width="100%" style="text-align: left;">
                                <p>
                                    <strong><span style="font-family: 'Times New Roman';font-size: 22px">Sunday, November 23rd, 2025</span></strong>
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong></strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong></strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">08:30-08:35 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Welcome Remarks by Dr. Weiguo Zou, President of Hainan Medical University</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">08:35-08:45 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Opening Remarks and comments and advises on the development of ICAC by Dr. Zhu Chen, Honorary Chair of the ICAC SAB</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">08:45-08:55 AM</p>
                                <p class="time-text">(EST, 22/11/2025,7:45-7:55 PM)</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Opening Remarks by Dr. Samuel Waxman, Co-Chair of the ICAC SAB</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">08:55-09:25 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Progress report of ICAC, by Dr. Ruibao Ren, Director of ICAC</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">09:25-10:40 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text" style="font-size: 18px;">Project report by Principal Investigators of ICAC （15min for each person）</p>
                                <p class="break-text" style="font-size: 18px;">Project report by Dr. Jianwei Wang, Principal Investigator of ICAC</p>
                                <p class="break-text" style="font-size: 18px;">Project report by Dr. Zhiguang Chang, Principal Investigator of ICAC</p>
                                <p class="break-text" style="font-size: 18px;">Project report by Dr. Yaobin Jing, Principal Investigator of ICAC </p>
                                <p class="break-text" style="font-size: 18px;">Project report by Dr. Jiangbin Ye, Principal Investigator of ICAC</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">10:40-11:10 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Comments and advice by members of the ICAC SAB</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">11:10-11:30 AM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Summary by Dr. Samuel Waxman and Dr. Saijuan Chen, Co-Chairs of the ICAC Scientific Advisory Board</p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="session-header">
                                <p class="session-title">
                                    <strong>YOUNG SCIENTIST FORUM </strong>
                                </p>
                                <p class="host-info">
                                    <strong>HOST: RUIBAO REN</strong>
                                </p>
                            </td>
                        </tr>
                        <tr class="table-header">
                            <td class="time-column">
                                <p class="header-text">
                                    <strong>TIME</strong>
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="header-text">
                                    <strong>Abstract</strong>
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="header-text">
                                    <strong>SPEAKER</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                   3:00-3:20 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   SIN3A facilitates SUMO2/3-mediated stabilization of KAP1–Lamin A/C complex to enforce LINE1 silencing and prevent premature senescence
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Zhuobin Liang</strong>
                                </p>
                                <p class="speaker-affiliation">
                                   Shenzhen Bay Laboratory Institute of Molecular Physiology
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    3:20-3:40 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   NAD+/NADH levels limit dietary restriction induced stress responses and health benefits in old mice
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Yulin Chen </strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Leibniz Institute on Aging –Fritz Lipmann Institute
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    3:40-4:00 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   Intermittent Hypobaric Pressure: a new strategy to alleviate injury of ionizing radiation
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Wenjing Yang</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Hainan Medical University
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:00-4:20 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   Defective SIRT1 Drives Psoriasiform Dermatitis via activation of STAT6 to transactivate FABP5
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Yue Luo</strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Sichuan University
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                    4:20-4:40 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   Increased clonal hematopoiesis in thalassemia
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Zhui Chen </strong>
                                </p>
                                <p class="speaker-affiliation">
                                    Hainan Medical University
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">
                                   4:40-5:00 PM
                                </p>
                                <p class="time-text">
                                    15min+5min Q & A
                                </p>
                            </td>
                            <td class="title-column">
                                <p class="title-text">
                                   Novel strategy for targeted clearance of intracellular α-Synuclein aggregates
                                </p>
                            </td>
                            <td class="speaker-column">
                                <p class="speaker-name">
                                    <strong>Tiantian Zou</strong>
                                </p>
                                <p class="speaker-affiliation">
                                   Hainan Medical University
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td class="time-column">
                                <p class="time-text">5:00-6:00 PM</p>
                            </td>
                            <td class="break-time" colspan="2">
                                <p class="break-text">Certificate Presentation</p>
                            </td>
                        </tr>
                        
                    </tbody>
                </table> -->
                <div class="program-tip"><p>To Watch the Live conference, <a href="https://nliafz.ktwhrskjyxgs0aaa.com.cn/live/page/307232583?v=1762827854045" target="_blank">click Here,</a></p></div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.conference-program {
    padding: 40px 0;
    width: 100%;

    .title {
        h3 {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #303030;
            margin-bottom: 60px;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 0;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .program-container {
        margin: 0 auto;
        width: 1440px;
        display: flex;
        justify-content: center;

        .program-content {
            width: 100%;

            .program-tip {
                margin-bottom: 20px;
                p {
                    font-size: 16px;
                    color: #303030;
                    text-align: center;
                }
            }

            .responstable {
                font-family: 'Times New Roman', serif;
                border-collapse: collapse;
                margin: 1em 0;
                width: 100%;
                overflow: hidden;
                background: #fff;
                color: #024457;
                border-radius: 10px;
                border: 1px solid #167f92;

                th,
                td {
                    padding: 1em;
                    vertical-align: middle;
                    word-break: break-word;
                }

                td {
                    border-bottom: 1px solid #d9e4e6;
                }

                // 日期标题样式
                .date-header {
                    text-align: left;

                    .date-text {
                        font-size: 22px;
                        margin: 0;
                    }
                }

                // 会议环节标题样式
                .session-header {
                    text-align: center;

                    .session-title {
                        font-size: 22px;
                        margin: 0 0 10px 0;
                    }

                    .host-info {
                        font-size: 16px;
                        margin: 0;
                    }
                }

                // 表格头部样式
                .table-header {
                    background: #0F96C0;
                    color: #fff;

                    .header-text {
                        text-align: center;
                        font-size: 18px;
                        margin: 0;
                    }
                }

                // 时间列样式
                .time-column {
                    width: 33%;
                    text-align: center;
                    white-space: nowrap;

                    .time-text {
                        font-size: 16px;
                        margin: 0;
                    }
                }

                // 内容列样式
                .content-column {
                    .content-text {
                        font-size: 16px;
                        margin: 0;
                    }
                }

                // 演讲者信息样式
                .speaker-column {
                    width: 33%;
                    text-align: center;

                    .speaker-name {
                        font-size: 16px;
                        font-weight: bold;
                        margin: 0 0 5px 0;
                    }

                    .speaker-affiliation {
                        font-size: 16px;
                        margin: 0;
                    }
                }

                // 标题列样式
                .title-column {
                    width: 33%;
                    text-align: left;
                    .header-text {
                        text-align: left;
                    }

                    .title-text {
                        font-size: 16px;
                        margin: 0;
                        text-align: left;
                    }
                }

                // 休息时间样式
                .break-time {
                    text-align: center;

                    .break-text {
                        font-size: 22px;
                        // font-weight: bold;
                        margin: 0;
                    }
                }
            }
        }
    }

    // 移动端适配
    @media (max-width: 768px) {
        padding: 20px 0;

        .title {
            h3 {
                font-size: 24px;
                margin-bottom: 30px;

                em {
                    width: 30px;
                    height: 10px;
                }

                span {
                    font-size: 22px;
                    margin: 0 15px;
                }
            }
        }

        .program-container {
            width: 100%;
            padding: 0 15px;

            .program-content {
                .responstable {
                    font-size: 14px;
                    border-radius: 8px;
                    margin: 0.8em 0;
                    table-layout: fixed;
                    word-wrap: break-word;

                    th,
                    td {
                        padding: 0.8em 0.5em;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        hyphens: auto;
                    }

                    // 日期标题移动端样式
                    .date-header {
                        .date-text {
                            font-size: 18px;
                            text-align: center;
                        }
                    }

                    // 会议环节标题移动端样式
                    .session-header {
                        .session-title {
                            font-size: 18px;
                            margin-bottom: 8px;
                        }

                        .host-info {
                            font-size: 14px;
                        }
                    }

                    // 表格头部移动端样式
                    .table-header {
                        .header-text {
                            font-size: 14px;
                        }
                    }

                    // 时间列移动端样式
                    .time-column {
                        width: 25%;
                        white-space: normal;
                        word-break: break-word;

                        .time-text {
                            font-size: 12px;
                            line-height: 1.3;
                        }
                    }

                    // 内容列移动端样式
                    .content-column {
                        .content-text {
                            font-size: 13px;
                            line-height: 1.4;
                        }
                    }

                    // 标题列移动端样式
                    .title-column {
                        width: 40%;

                        .header-text {
                            text-align: center;
                        }


                        .title-text {
                            font-size: 13px;
                            line-height: 1.4;
                            text-align: center;
                        }
                    }

                    // 演讲者列移动端样式
                    .speaker-column {
                        width: 35%;
                        text-align: center;

                        .speaker-name {
                            font-size: 13px;
                            margin-bottom: 3px;
                            line-height: 1.3;
                        }

                        .speaker-affiliation {
                            font-size: 12px;
                            line-height: 1.3;
                        }

                        .speaker-text {
                            font-size: 13px;
                            margin: 0 0 3px 0;
                            line-height: 1.3;
                        }
                    }

                    // 休息时间移动端样式
                    .break-time {
                        .break-text {
                            font-size: 16px;
                        }
                    }

                    // 移动端特殊处理：三列表格布局优化
                    tr {
                        td[width="33%"] {
                            width: auto !important;
                            display: table-cell;
                            vertical-align: top;
                        }

                        // 针对内联样式的覆盖 - 增强优先级
                        td[style*="font-family: 'Times New Roman'"] {
                            span[style*="font-size"] {
                                font-size: 13px !important;
                                line-height: 1.4 !important;
                            }
                            
                            p {
                                span[style*="font-size"] {
                                    font-size: 13px !important;
                                    line-height: 1.4 !important;
                                }
                            }
                        }

                        // 蓝色头部行的移动端适配 - 增强覆盖
                        &[style*="background: rgb(15, 150, 192)"],
                        &[style*="background: #0F96C0"] {
                            td {
                                padding: 0.6em 0.3em !important;

                                p {
                                    margin: 0 !important;

                                    span[style*="font-size"] {
                                        font-size: 14px !important;
                                        line-height: 1.3 !important;
                                    }
                                }
                            }
                        }

                        // 强制覆盖所有内联字体大小
                        td {
                            // 覆盖nowrap属性
                            white-space: normal !important;
                            
                            span[style*="font-size: 22px"] {
                                font-size: 16px !important;
                            }
                            
                            span[style*="font-size: 18px"] {
                                font-size: 14px !important;
                            }
                            
                            span[style*="font-size: 16px"] {
                                font-size: 13px !important;
                            }
                            
                            p {
                                span[style*="font-size: 22px"] {
                                    font-size: 16px !important;
                                }
                                
                                span[style*="font-size: 18px"] {
                                    font-size: 14px !important;
                                }
                                
                                span[style*="font-size: 16px"] {
                                    font-size: 13px !important;
                                }
                            }
                        }
                        
                        // 覆盖nowrap属性
                        td[nowrap] {
                            white-space: normal !important;
                        }
                    }
                }
            }
        }
    }

    // 超小屏幕适配 (小于480px)
    @media (max-width: 480px) {
        padding: 15px 0;

        .title {
            h3 {
                font-size: 20px;
                margin-bottom: 25px;

                em {
                    width: 25px;
                    height: 8px;
                }

                span {
                    font-size: 18px;
                    margin: 0 10px;
                }
            }
        }

        .program-container {
            padding: 0 10px;

            .program-content {
                .responstable {
                    font-size: 12px;
                    border-radius: 6px;

                    th,
                    td {
                        padding: 0.6em 0.3em;
                    }

                    .date-header {
                        .date-text {
                            font-size: 16px;
                        }
                    }

                    .session-header {
                        .session-title {
                            font-size: 16px;
                        }

                        .host-info {
                            font-size: 12px;
                        }
                    }

                    .table-header {
                        .header-text {
                            font-size: 12px;
                        }
                    }

                    .time-column {
                        width: 22%;

                        .time-text {
                            font-size: 11px;
                        }
                    }

                    .title-column {
                        width: 42%;
                        .header-text {
                            text-align: center;
                        }

                        .title-text {
                            font-size: 12px;
                            text-align: center;
                        }
                    }

                    .speaker-column {
                        width: 36%;
                        text-align: center;

                        .speaker-name {
                            font-size: 12px;
                        }

                        .speaker-affiliation {
                            font-size: 11px;
                        }

                        .speaker-text {
                            font-size: 12px;
                        }
                    }

                    .content-column {
                        .content-text {
                            font-size: 12px;
                        }
                    }

                    .break-time {
                        .break-text {
                            font-size: 14px;
                        }
                    }

                    // 超小屏幕的内联样式覆盖 - 增强优先级
                    tr {
                        td[style*="font-family: 'Times New Roman'"] {
                            span[style*="font-size"] {
                                font-size: 12px !important;
                                line-height: 1.3 !important;
                            }
                            
                            p {
                                span[style*="font-size"] {
                                    font-size: 12px !important;
                                    line-height: 1.3 !important;
                                }
                            }
                        }

                        &[style*="background: rgb(15, 150, 192)"],
                        &[style*="background: #0F96C0"] {
                            td {
                                padding: 0.5em 0.2em !important;

                                p span[style*="font-size"] {
                                    font-size: 12px !important;
                                }
                            }
                        }

                        // 超小屏幕强制覆盖所有内联字体大小
                        td {
                            // 覆盖nowrap属性
                            white-space: normal !important;
                            
                            span[style*="font-size: 22px"] {
                                font-size: 14px !important;
                            }
                            
                            span[style*="font-size: 18px"] {
                                font-size: 12px !important;
                            }
                            
                            span[style*="font-size: 16px"] {
                                font-size: 12px !important;
                            }
                            
                            p {
                                span[style*="font-size: 22px"] {
                                    font-size: 14px !important;
                                }
                                
                                span[style*="font-size: 18px"] {
                                    font-size: 12px !important;
                                }
                                
                                span[style*="font-size: 16px"] {
                                    font-size: 12px !important;
                                }
                            }
                        }
                        
                        // 覆盖nowrap属性
                        td[nowrap] {
                            white-space: normal !important;
                        }
                    }
                }
            }
        }
    }

}
</style>